import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

const DowngradeConfirmationModal: React.FC<{
  isLossingFieldAppAccess: boolean;
  handleConfirmation: () => void;
}> = ({ handleConfirmation, isLossingFieldAppAccess }) => {
  const { t } = useTranslation();

  const { closeModal } = useModal();

  return (
    <div className='flex flex-col gap-16'>
      <Typography weight='medium' variant='h6'>
        {t('downgrade-confirmation-title')}
      </Typography>
      <Typography className='text-surface-10'>
        {t('downgrade-confirmation-description')}
      </Typography>

      <Typography className='text-surface-10'>
        <span className='font-semi-bold'>{t('access-loss')}: </span>
        <span>
          {t(isLossingFieldAppAccess ? 'access-loss-field' : 'access-loss-eye')}
        </span>
      </Typography>
      <Typography className='text-surface-10'>
        <span className='font-semi-bold'>{t('automatic-logout')}: </span>
        <span>
          {t(
            isLossingFieldAppAccess
              ? 'automatic-logout-field'
              : 'automatic-logout-eye'
          )}
        </span>
      </Typography>
      <Typography className='text-surface-10'>
        <span className='font-semi-bold'>{t('data-loss')}: </span>
        <span>
          {t(isLossingFieldAppAccess ? 'data-loss-field' : 'data-loss-eye')}
        </span>
      </Typography>

      <div className='mt-16 flex gap-16'>
        <Button
          size='full'
          className='!rounded-lg border-xs border-outline-default py-1'
          variant='text'
          onClick={() => closeModal()}
        >
          {t('cancel')}
        </Button>
        <Button
          size='full'
          className='!rounded-lg border-xs border-error-default py-1'
          color='red'
          onClick={handleConfirmation}
        >
          {t('confirm-downgrade')}
        </Button>
      </div>
    </div>
  );
};
export { DowngradeConfirmationModal };
